import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    contactNo: "",
    email: "",
    address: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // EmailJS code uncomment करा जेव्हा तयार असेल
    /* emailjs.send(...) ... */

    alert("तुमचा संदेश यशस्वीरित्या पाठवला गेला! (Demo)");
    setFormData({
      fullName: "",
      contactNo: "",
      email: "",
      address: "",
      message: "",
    });
  };

  return (
    <div className="contact-page">
      {/* Contact Info Section */}
      <section className="contact-info-section">
        <h2 className="section-title">संपर्क माहिती</h2>
        <div className="info-cards">
          <div className="info-card address-card">
            <div className="card-icon">📍</div>
            <h3>पत्ता</h3>
            <p>
              ग्रामपंचायत घोणसई - मेट <br />
              पंचायत समिती वाडा, जि. पालघर <br />
              महाराष्ट्र – 442201
            </p>
          </div>

          <div className="info-card phone-card">
            <div className="card-icon">📞</div>
            <h3>फोन / हेल्पलाइन</h3>
            <p>९२०९६१८९७९||८७६७४५३५४३</p>
            <p>सकाळी ९:०० ते दुपारी ५:००</p>
          </div>

          <div className="info-card email-card">
            <div className="card-icon">✉️</div>
            <h3>ई-मेल</h3>
            <p>vpzppalgharwadaghonsai@gmail.com</p>
          </div>
        </div>
      </section>

      {/* Google Map Section (Optional - Embed your location) */}
      <section className="map-section">
        <h2 className="section-title">आमचे स्थान</h2>
        <div className="map-container">
          {/* Google Map Embed - Replace src with your actual embed code */}
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d27444.98718131159!2d73.07903412469369!3d19.50008714913492!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7a01ed4c411dd%3A0xf60d5c7cc28899d2!2sGhonsai%2C%20Maharashtra%2C%20India!5e1!3m2!1sen!2sus!4v1773651849717!5m2!1sen!2sus"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="ग्रामपंचायत घोणसई - मेट स्थान"
          ></iframe>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section">
        <div className="form-container">
          <h1 className="form-heading">📞 संपर्क करा</h1>
          <p className="form-subheading">
            तुमचे प्रश्न, सूचना आणि अभिप्राय आमच्यासाठी महत्त्वाचे आहेत.
          </p>

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label>पूर्ण नाव *</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>संपर्क क्रमांक *</label>
              <input
                type="tel"
                name="contactNo"
                value={formData.contactNo}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>ई-मेल *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>पत्ता</label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                rows="3"
              />
            </div>

            <div className="form-group">
              <label>संदेश *</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="5"
                required
              />
            </div>

            <button type="submit" className="submit-btn">
              संदेश पाठवा →
            </button>
          </form>
        </div>
      </section>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;600;700&display=swap');

        .contact-page {
          font-family: 'Noto Sans Devanagari', sans-serif;
          background: linear-gradient(to bottom, #f0f8ff, #ffffff);
          min-height: 100vh;
          padding: 40px 20px;
        }

        .section-title {
          text-align: center;
          font-size: 2.2rem;
          font-weight: 700;
          color: #001f3f; /* Navy */
          margin-bottom: 40px;
          position: relative;
        }

        .section-title::after {
          content: '';
          width: 100px;
          height: 4px;
          background: linear-gradient(to right, #001f3f, #a8daf9);
          position: absolute;
          bottom: -12px;
          left: 50%;
          transform: translateX(-50%);
          border-radius: 2px;
        }

        /* Info Cards */
        .contact-info-section {
          max-width: 1200px;
          margin: 0 auto 60px;
        }

        .info-cards {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 25px;
        }

        .info-card {
          background: #ffffff;
          border-radius: 12px;
          padding: 30px 20px;
          text-align: center;
          box-shadow: 0 8px 25px rgba(0, 31, 63, 0.08);
          transition: all 0.3s ease;
          border: 1px solid #cce4ff;
        }

        .info-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 15px 35px rgba(0, 75, 141, 0.15);
        }

        .card-icon {
          font-size: 2.5rem;
          margin-bottom: 15px;
        }

        .info-card h3 {
          font-size: 1.4rem;
          color: #001f3f;
          margin-bottom: 12px;
        }

        .info-card p {
          color: #444;
          line-height: 1.6;
        }

        /* Map Section */
        .map-section {
          max-width: 1200px;
          margin: 0 auto 60px;
        }

        .map-container {
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          border: 2px solid #a8daf9;
        }

        /* Form Section */
        .contact-form-section {
          max-width: 900px;
          margin: 0 auto;
        }

        .form-container {
          background: #ffffff;
          padding: 50px 40px;
          border-radius: 16px;
          box-shadow: 0 10px 40px rgba(0, 31, 63, 0.1);
          border-top: 5px solid #001f3f;
        }

        .form-heading {
          font-size: 2.5rem;
          color: #001f3f;
          text-align: center;
          margin-bottom: 10px;
        }

        .form-subheading {
          text-align: center;
          color: #555;
          margin-bottom: 40px;
          font-size: 1.1rem;
        }

        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .form-group label {
          display: block;
          margin-bottom: 8px;
          font-weight: 600;
          color: #001f3f;
        }

        .form-group input,
        .form-group textarea {
          width: 100%;
          padding: 14px;
          border: 2px solid #cce4ff;
          border-radius: 8px;
          font-size: 1rem;
          transition: border 0.3s;
        }

        .form-group input:focus,
        .form-group textarea:focus {
          border-color: #004b8d;
          outline: none;
          box-shadow: 0 0 0 3px rgba(168, 218, 249, 0.3);
        }

        .submit-btn {
          background: #001f3f;
          color: white;
          padding: 15px;
          border: none;
          border-radius: 8px;
          font-size: 1.2rem;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s;
          margin-top: 10px;
        }

        .submit-btn:hover {
          background: #004b8d;
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 75, 141, 0.3);
        }

        /* Responsive */
        @media (max-width: 768px) {
          .form-container {
            padding: 30px 20px;
          }
          .form-heading {
            font-size: 2rem;
          }
          .section-title {
            font-size: 1.8rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Contact;